<template>
	<div>
		<div class="pg-header">
			<div>
				<label class="title">科室管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<!-- <router-link to="/">患者管理</router-link>| -->
					<span>系统管理</span>|
					<span class="active">科室管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>

		<div class="table-wrap">
			<div class="search-bar">
				<label>科室ID
					<el-input size="small" placeholder="科室ID" style="width:10%;" clearable v-model.trim="filter.id"
						@keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<label>科室名称
					<el-input size="small" placeholder="科室名称" style="width:10%;" clearable v-model.trim="filter.name"
						@keyup.enter.native="handleFilter(1)"></el-input>
				</label>
				<div style="display: inline-block;">科室类型
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.departmentType"
						@change="handleFilter(3, $event)">
						<el-option label="住院科室" :value="0"></el-option>
						<el-option label="门诊科室" :value="1"></el-option>
					</el-select>
				</div>
				<div style="display: inline-block;">是否管理
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.departmentState"
						@change="handleFilter(4, $event)">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</div>
				<div style="display: inline-block;">所属机构
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.orgId"
						@change="handleFilter(5, $event)">
						<el-option v-for="item in sysOrgList" :key="item.id" :label="item.orgName"
							:value="item.id"></el-option>
					</el-select>
				</div>
				<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="openDlog" v-if="hospitalCode != 'FJ_SM2'">批量修改</el-button>

				<el-button type="primary" size="mini" round @click="showDlg">新增科室</el-button>
				<el-upload style="display:inline-block;" action="" :show-file-list="false" :before-upload="onUpload">
					<el-button type="primary" size="mini" round>导入科室</el-button>
				</el-upload>

				<!-- <el-button type="primary" size="mini" round @click="onImport">导入科室</el-button> -->
				<el-button type="text" size="mini" @click="showDlg">下载导入模版文件</el-button>

				<!-- <el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
				</el-popconfirm> -->
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
				:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<el-table-column fixed="left" type="selection" width="55"></el-table-column>
				<el-table-column prop="name" label="科室名称" show-overflow-tooltip></el-table-column>
				<!-- <el-table-column prop="description" label="模板描述" show-overflow-tooltip></el-table-column> -->
				<el-table-column label="科室类型" width="200">
					<template slot-scope="scope">
						<span v-if="scope.row.departmentType === 0">住院科室</span>
						<span v-else-if="scope.row.departmentType == 1">门诊科室</span>
					</template>
				</el-table-column>
				<el-table-column prop="orgName" label="所属机构"></el-table-column>
				<el-table-column label="是否管理">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.departmentState === 1" type="success" size="mini"><i
								class="el-icon-check"></i></el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="reviserName" label="更新人" width="200"></el-table-column>
				<el-table-column prop="date" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip> -->
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline"
									@click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i
										class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
								v-text="(filter.pageNumber - 1) * filter.pageSize + filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
							:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
							:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
							@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改科室' : '新增科室'" width="660px" center :visible.sync="dlg.active">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="科室HIS ID" prop="hisDepartmentId">
					<el-input autocomplete="off" :show-word-limit="true" v-model="form.hisDepartmentId"></el-input>
				</el-form-item>
				<el-form-item label="科室名称" prop="name">
					<el-input autocomplete="off" maxlength="20" :show-word-limit="true" v-model="form.name"></el-input>
				</el-form-item>

				<el-form-item label="科室类型" prop="departmentType">
					<el-select filterable clearable v-model="form.departmentType" placeholder="请选择">
						<el-option label="住院科室" :value="0"></el-option>
						<el-option label="门诊科室" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属机构" prop="orgId">
					<el-select filterable clearable v-model="form.orgId" placeholder="请选择">
						<el-option v-for="item in sysOrgList" :key="item.id" :label="item.orgName"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="是否管理" prop="departmentState">
					<el-radio-group v-model="form.departmentState">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<template  v-if="form.departmentState == 1" >

					<el-form-item label="是否按诊断自动排期" prop="autoSchedulingState">
						<el-radio-group v-model="form.autoSchedulingState">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="form.autoSchedulingState == 1" label="历史数据处理" prop="oldDate">
								<el-date-picker
								v-model="form.oldDate"
								type="date"
								placeholder="选择日期"
								>
							</el-date-picker>前的待排期患者将自动勿访
					</el-form-item>
					<p class="tips" v-if="form.autoSchedulingState == 1">自动排期模板在系统管理-排期模板中修改</p>
				</template>

				<el-form-item label="按照标签管理" prop="tagState" v-if="hospitalCode == 'FJ_SM2' && form.departmentState == 1">
					<el-radio-group v-model="form.tagState">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		<!-- 批量修改 -->
		<el-dialog title="修改科室" width="660px" center :visible.sync="dlg1.active" custom-class="builEdit">
			<el-form ref="form1" label-width="120px" :rules="dlg1.rules" :model="form1">
				<el-form-item label="是否管理" prop="depState">
					<el-radio-group v-model="form1.depState">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<template v-if="form1.depState == 1">
					<el-form-item  label="是否按诊断自动排期" prop="autoSchedulingState">
						<el-radio-group v-model="form1.autoSchedulingState">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="form1.autoSchedulingState == 1" label="历史数据处理" prop="oldDate">
							<el-date-picker
								v-model="form1.oldDate"
								type="date"
								placeholder="选择日期"
								>
							</el-date-picker>前的待排期患者将自动勿访
					</el-form-item>
					<p class="tips" v-if="form1.autoSchedulingState == 1">自动排期模板在系统管理-排期模板中修改</p>
				</template>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="updateform">保 存</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data() {
		return {
			dlg: {
				active: false,
				rules: {
					hisDepartmentId: { required: true, message: '请输入', trigger: 'blur' },
					name: { required: true, message: '请输入', trigger: 'blur' },
					departmentType: { required: true, message: '请选择', trigger: 'change' },
					orgId: { required: true, message: '请选择', trigger: 'change' },
					departmentState: { required: true, message: '请选择', trigger: 'change' },
					oldDate: { required: true, message: '请选择', trigger: 'change' },
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				orgId: '',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				name: '',
				departmentType: undefined,
				departmentState: undefined,
				hisDepartmentId: undefined,
				orgId: undefined,
				tagState: 0,
				autoSchedulingState: 0,
				oldDate:''
			},
			templateList: [],
			sysOrgList: [],
			dlg1: {
				active: false,

				rules: {
					depState: { required: true, message: '请选择', trigger: 'change' },
					oldDate: { required: true, message: '请选择', trigger: 'change' },

				}
			},
			form1: {
				depState: null,
				depIdListStr: [],
				oldDate:'',
				autoSchedulingState: 0,
			},
			multipleSelection: [],
			hospitalCode: 'YS_HM4',

		}
	},
	async created() {
		this.loadList();
		// 所属机构
		this.loadSysOrgAll();
		this.hospitalCode = await api.getHospitalCode();

	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getDeptList(this.filter);
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item) => {
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async loadSysOrgAll() {
			let res = await api.getSysOrgAll();
			this.sysOrgList = res.data;
		},
		getLastDay(){
			const date = new Date();
					date.setDate(date.getDate());

					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要 +1
					const day = String(date.getDate()).padStart(2, '0');

					let lastday = `${year}-${month}-${day}`;
					return lastday;
		},
		showDlg(item) {
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(async () => {
					let res = await api.getDept({ depId: item.id });
					if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
					res.data.orgId = +res.data.orgId;
					this.$refs['form'].resetFields();
					this.form = { ...res.data, oldDate: this.getLastDay() }; // 在这里合并 oldDate
				});
			} else {
				this.form.id = 0;
				this.$nextTick(() => {
					this.$refs['form'].resetFields();
					this.form.oldDate = this.getLastDay();
				});
			}
		},
		async saveForm() {
			let res;
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					if(this.form.oldDate){
						this.form.oldDate = dayjs(this.form.oldDate).format('YYYY-MM-DD')
					}
					this.isLoading = true;
					if (this.form.departmentState == 0) {
						this.form.tagState = 0;
					}
					if (this.form.id > 0) {
						res = await api.editDept(this.form);
					} else {
						// 后端问题，不能带这参数
						// this.form.id = null;
						res = await api.addDept(this.form);
					}
					this.isLoading = false;
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({ message: '保存成功', type: 'success' });
					this.dlg.active = false;
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return; }

			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delDept({ depId: item.id });
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delDept({ depIds: this.multipleSelection.join(',') });
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({ message: '已删除', type: 'success' });
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		async onUpload(file) {
			let formData = new FormData();
			formData.append("file", file);
			const res = await api.importDept(formData);
			return false;
		},
		selectionChange(selected) {
			let selection = []
			selected.forEach((item) => {
				selection.push(item);
			})
			this.multipleSelection = selection;

		},
		openDlog() {
			if (this.multipleSelection.length == 0) { return this.$message.warning('未选择任何数据'); }
			this.dlg1.active = true;
			this.$nextTick(() => {
				this.$refs['form1'].resetFields();
				this.form1.oldDate = this.getLastDay();
			})

		},
		async updateform() {
			this.form1.depIdListStr = this.multipleSelection.map(item => item.id).join(',');
			if(this.form1.oldDate){
				this.form1.oldDate = dayjs(this.form1.oldDate).format('YYYY-MM-DD')
			}
			let res = await api.updateStateList(this.form1);
			if (res.code != 1000) { return this.$message.error(res.message); }
			this.$message.success('修改成功');
			this.dlg1.active = false;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

::v-deep .el-form-item {
	label:not(.el-radio) {
		width: 160px !important;
	}
}

::v-deep .el-form .el-input:not(.el-transfer-panel__filter) {
	width: 256px !important;
}

::v-deep .builEdit {
	.el-dialog--center .el-dialog__body {
		padding: 25px 64px 30px !important;
	}
}

.tips {
	color: #699CE4;
	text-align: center;
}</style>
